import './Header.css'
import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from '../../assets/images/logo.jpg'






const Header = () => {

  const [displayusername, displayusernameupdate] = useState('');
  const [showmenu, showmenuupdateupdate] = useState(false);
  const usenavigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    if (location.pathname === '/account') {
      showmenuupdateupdate(true);
      let username = sessionStorage.getItem('username');
      if (username === '' || username === null) {
        usenavigate('/login');
      } else {
        displayusernameupdate(username);
      }
    }
    else { showmenuupdateupdate(false); }

  }, [location, showmenu, usenavigate])

  return (
    <div className='border-bottom'>
      {showmenu &&
        <div className="header container my-2">

          <div className="header-l">
            <div className="mx-2 my-1">
              <Link to={'/account'} >
                <img src={logo} alt='logo' className="imgheader"/>
              </Link>
            </div>
            <div className="">
              <pre className='text-success my-1'>Welcome   <b className='text-info'>** {displayusername} **</b></pre>
            </div>
          </div>


          <div className="header-r scall">
            <div className="m-2">
              <Link to={'/register'} type="button" className="btn btn-warning ">Register</Link>
            </div>
            <div className="">
              <Link to={'/login'} type="button" className="btn btn-danger ">Logout</Link>
            </div>
          </div>

        </div>
      }
    </div >
  );
}

export default Header;